import React, {useState} from "react";
import { DatePicker } from "antd";
import { useSearchParams } from "react-router-dom";
import moment from "moment";
import { ClockCircleOutlined } from "@ant-design/icons";
import CheckableTag from "antd/es/tag/CheckableTag";

const { RangePicker } = DatePicker;

const DateRange = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [showTime, setShowTime]         = useState<boolean>(false);
  const dateFrom        = searchParams.get('date_from');
  const dateTo          = searchParams.get('date_to');
  let defaultValue: any = null;

  if (dateFrom && dateTo) {
    defaultValue = [
      moment.unix(parseInt(dateFrom, 10)),
      moment.unix(parseInt(dateTo, 10))
    ];
  }

  function onChange(data: any) {
    if (data) {
      const dateFrom = showTime ? data[0] : data[0].startOf('day');
      const dateTo   = showTime ? data[1] : data[1].endOf('day');

      searchParams.set('date_from', dateFrom.unix().toString());
      searchParams.set('date_to', dateTo.unix().toString());
    } else {
      searchParams.delete('date_from');
      searchParams.delete('date_to');
    }

    setSearchParams(searchParams, { replace: true });
  }

  return (
    <div className='v-filter__daterange'>
      <RangePicker
        ranges={{
          Yesterday: [
            moment().utc().subtract(1, 'days').startOf('day'),
            moment().utc().subtract(1, 'days').endOf('day')
          ],
          Today: [
            moment().utc().startOf('day'),
            moment().utc().endOf('day')
          ],
          'Last Week': [
            moment().utc().subtract(1, 'weeks').startOf('week'),
            moment().utc().subtract(1, 'weeks').endOf('week')
          ],
          'This Week': [
            moment().utc().startOf('week'),
            moment().utc().endOf('week')
          ],
          'This Month': [
            moment().utc().startOf('month'),
            moment().utc().endOf('month')
          ],
          'Last Month': [
            moment().utc().subtract(1, 'months').startOf('month'),
            moment().utc().subtract(1, 'months').endOf('month')
          ],
        }}
        defaultValue={defaultValue}
        showTime={showTime}
        bordered={false}
        size='small'
        onChange={onChange}
      />

      <CheckableTag
        checked={showTime}
        onChange={() => setShowTime(!showTime)}
      >
        <ClockCircleOutlined />
      </CheckableTag>
    </div>
  );
}

export default DateRange;
